import { render, staticRenderFns } from "./VueGoodTable.vue?vue&type=template&id=0932a78f&"
import script from "./VueGoodTable.vue?vue&type=script&lang=js&"
export * from "./VueGoodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports